import { defineComponent } from "vue";
import { ChallengePickDropZone } from "@/data/challenges/challengePickDropZone";
import Image from "@/components/core/Image.vue";
import Button from '@/components/core/Button.vue';
import router from '@/router';
import DropZone from "@/components/core/DropZone.vue";
import modalHandler from "@/data/modalHandler";
import audioHandler from "@/data/audioHandler";
import pageHookMixin from "@/data/pageHookMixin";
export default defineComponent({
    name: 'ChallengePickDropZone',
    mixins: [pageHookMixin],
    components: {
        DropZone,
        Image,
        Button
    },
    props: {
        challenge: {
            type: ChallengePickDropZone
        },
        forwardUrl: {
            type: String
        },
        showMotivationModal: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        buttonColor(newState, oldState) {
            if (newState === 'orange' && oldState !== newState) {
                audioHandler.play('select');
            }
        }
    },
    computed: {
        solved() {
            if (this.challenge) {
                return this.challenge.state === 'solved';
            }
            return false;
        },
        buttonColor() {
            if (this.challenge) {
                if (this.solved) {
                    return 'green';
                }
                if (this.challenge?.state === 'chosen') {
                    return 'orange';
                }
            }
            return 'gray';
        },
    },
    data() {
        return {
            dropZoneStates: this.challenge?.getDropZoneStates() || {}
        };
    },
    methods: {
        onScreenUpdate() {
            router.go(0);
        },
        updateDropZone() {
            if (this.challenge && this.challenge.getNumberOfDropZones() < 1) {
                const dropZones = this.$el.querySelectorAll('.dropZone');
                for (const dz in dropZones) {
                    if (!isNaN(Number(dz))) {
                        const dropZone = dropZones[dz];
                        const dropZoneKey = Number(dropZone.dataset.dropZoneKey);
                        this.challenge?.registerDropZone(dropZoneKey, dropZone.getBoundingClientRect());
                    }
                }
                // eslint-disable-next-line vue/no-mutating-props
                this.challenge?.sortDropZones();
            }
        },
        draggableOnMove(itemKey, cursorX, cursorY) {
            this.updateDropZone();
            this.challenge?.selectItemDropZone(itemKey, cursorX, cursorY);
            this.dropZoneStates = this.challenge?.getDropZoneStates() || [];
        },
        onForwardButtonClick() {
            if (this.challenge?.state === 'solved' && this.forwardUrl) {
                if (this.showMotivationModal) {
                    modalHandler.show('motivation', {
                        forwardUrl: this.forwardUrl
                    });
                }
                else {
                    router.replace(this.forwardUrl);
                }
            }
            if (this.challenge?.state === 'chosen') {
                this.dropZoneStates = this.challenge?.getDropZoneStates() || [];
                this.challenge.evaluate();
            }
        }
    }
});
